import React from 'react';
import AboutUs from '../../components/About/About_us.jsx';
import GameAccessories from '../../components/About/GameAccessories';
import Offer from '../../components/About/Offer';
import Mask from '../../components/About/Mask';
// import Logo from '../../components/footer/logo/Logo';

function About() {
  return (
    <div>
      <AboutUs />
      <GameAccessories />
      <Offer />
      <Mask />
    </div>
  );
}

export default About;
